import { useEffect, useState } from 'react';
import { listAccountProducts, quoteCartLines } from '../../api';
import { ownedRowsState, priceLine } from '../../lib/cartQuote';

// Rows picked from the account's products. null while loading (or not asked
// yet), { error } when the read failed or came back short with none of them,
// otherwise the picked rows. retry() asks again.
//   pick: products[] → rows[]; a module-level function, so stable.
export function useAccountRows({ accountId, enabled, pick }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!enabled || !accountId || rows != null) return;
    let cancelled = false;
    listAccountProducts(accountId)
      .then(r => { if (!cancelled) setRows(ownedRowsState(pick(r.products), r.productsComplete)); })
      .catch(e => { if (!cancelled) setRows({ error: e.message || 'request failed' }); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, accountId, rows]);
  return [rows, () => setRows(null)];
}

// Price a line with squish-backend, then hand the priced cart item to the
// builder. `error` is squish-backend's refusal, written for the rep.
export function useQuotedAdd({ accountId, prospect, onAdd }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  async function add(line, lineId) {
    if (busy) return false;
    setError('');
    setBusy(true);
    try {
      onAdd(await priceLine({ quote: quoteCartLines, line, lineId, accountId, prospect }));
      return true;
    } catch (e) {
      setError(e.message || 'Could not price that line');
      return false;
    } finally {
      setBusy(false);
    }
  }
  return { add, busy, error, clearError: () => setError('') };
}
